module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-180x180-precomposed-6c0c159096e27cb780e32ec56894af22.png";